module.exports = __webpack_public_path__ + "static/img/lv.eeafeb0f.svg";